import { LoginService } from "./../../login/login.service";
import { Injectable } from "@angular/core";
import { Observable, Subject, firstValueFrom } from "rxjs";
import { environment } from "../../../environments/environment";

import { LocalStorageService } from "src/app/utils/localstorage.service";
import { HttpClient, HttpEventType, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs";
import { IConversation } from "./panels/conversation.model";

@Injectable({ providedIn: "root" })
export class ConversationsService {
  public connection: any;
  public connectedObservable = new Subject();
  showTrackedItems = new Subject();
  showOpenTrackedItems = new Subject();
  connected = false;
  headers = new Headers();
  // options: RequestOptions;

  // Badges
  unread_conversations: number = 0;
  opened_tracked_items: number = 0;
  total_tracked_items: number = 0;
  read_status = [];

  // Subjects
  opened_conversation = new Subject(); //TODO: Remove
  active_conversation = new Subject(); //TODO: Remove
  conversation_added = new Subject(); //TODO: Remove
  conversations_loaded = new Subject();
  updateUnreadConversations = new Subject();
  getTrackedItemsTabCountSubject = new Subject();

  newPlaceholderTrackedItems = new Subject();

  updateTrackedItem$: Subject<any> = new Subject();
  forceUnread = new Subject<any>();

  toggleArchivedConversations = new Subject();

  // ChatEngineCore = (<any>window).ChatEngineCore;
  public isConversationScreenOpened = false;

  public listeners = [];

  public constructor(
    private localStorage: LocalStorageService,
    public _http: HttpClient,
    public loginService: LoginService,
  ) {}

  add_conversation(name, users, members, company_id): Promise<any> {
    const data = {
      name: name,
      users: users,
      members: members,
      company: company_id,
    };

    return this._http
      .post(`${environment.apiUrl}/conversations/`, data)
      .toPromise();
  }

  add_tracked_items(
    tracked_items,
    conversation_id,
    autoRemind: boolean,
    autoRemindDays: number,
  ): Promise<any> {
    const data = {
      tracked_items: tracked_items,
    };

    if (autoRemind) {
      data["remind_in"] = autoRemindDays;
    }

    return this._http
      .post(
        `${environment.apiUrl}/conversations/${conversation_id}/tracked`,
        data,
      )
      .toPromise();
  }

  addTrackedItemsV2(
    trackedItems,
    conversationId,
    autoRemind: boolean,
    autoRemindDays: number,
    files: FormData = null,
  ): Promise<any> {
    trackedItems.forEach((item) => {
      item["conversation_id"] = conversationId;
    });

    const data = {
      tracked_items: trackedItems,
    };

    if (autoRemind) {
      data["remind_in"] = autoRemindDays;
    }

    return this._http
      .post(`${environment.apiUrl}/v2/conversations/tracked`, data)
      .toPromise();
  }

  editTrackedItemV2FormData(files: FormData): Promise<any> {
    return this._http
      .patch(`${environment.apiUrl}/v2/conversations/tracked`, files)
      .toPromise();
  }

  addTrackedItemsV2FormData(files: FormData): Promise<any> {
    return this._http
      .post(`${environment.apiUrl}/v2/conversations/tracked`, files)
      .toPromise();
  }

  newAddTrackedItemsV2FormData(files: FormData): Observable<any> {
    const headers = new HttpHeaders();
    const url = `${environment.apiUrl}/v2/conversations/tracked`;
    return this._http
      .post(url, files, {
        headers,
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: "progress", message: progress };

            case HttpEventType.Response:
              return { status: "completed", response: event.body };
          }
        }),
      );
  }

  addBatchTrackedItemsV2FormData(files: FormData): Promise<any> {
    return this._http
      .post(
        `${environment.apiUrl}/v2/conversations/multiple-tracked-items`,
        files,
      )
      .toPromise();
  }

  addTrackedItemsTemplateV2FormData(data: FormData): Promise<any> {
    return this._http
      .post(`${environment.apiUrl}/conversations/tracked-items.template`, data)
      .toPromise();
  }

  createDrafts(
    trackedItems: any,
    conversationId,
    autoRemind: boolean,
    autoRemindDays: number,
  ): Promise<any> {
    const data = {
      tracked_items: trackedItems,
    };

    if (autoRemind) {
      data["remind_in"] = autoRemindDays;
    }

    return this._http
      .post(
        `${environment.apiUrl}/conversations/${conversationId}/drafts`,
        data,
      )
      .toPromise();
  }

  createDraftsV2(
    trackedItems: any,
    conversationId,
    autoRemind: boolean,
    autoRemindDays: number,
    isJobDraft = false,
  ): Promise<any> {
    console.log("isJobDraft", isJobDraft);

    trackedItems.forEach((item) => {
      item["conversation_id"] = conversationId;
    });

    const data = {
      tracked_items: trackedItems,
      isJobDraft: isJobDraft,
    };

    console.log(">>> Auto Remind", autoRemind, autoRemindDays);

    if (autoRemind) {
      data["remind_in"] = autoRemindDays;
    }

    return this._http
      .post(`${environment.apiUrl}/v2/conversations/drafts`, data)
      .toPromise();
  }

  createDraftsV2FormData(data: FormData): Promise<any> {
    data.append("isJobDraft", "true");
    return this._http
      .post(`${environment.apiUrl}/v2/conversations/drafts`, data)
      .toPromise();
  }

  getTrackedItemAttachments(trackedItemUuid: number) {
    return this._http.get(
      `${environment.apiUrl}/v2/conversations/tracked-item/${trackedItemUuid}/attachments`,
    );
  }

  getTrackedItemFiles(trackedItemUuid: number) {
    return this._http.get(
      `${environment.apiUrl}/v2/conversations/tracked-item/${trackedItemUuid}/files`,
    );
  }

  deleteTrackedItem(trackedItemUuid: string) {
    return this._http.delete(
      `${environment.apiUrl}/v2/conversations/tracked-item/${trackedItemUuid}`,
    );
  }

  add_tracked_items_template(tracked_items, name): Promise<any> {
    const data = {
      tracked_items: tracked_items,
      name: name,
    };

    return this._http
      .post(`${environment.apiUrl}/conversations/tracked-items.template`, data)
      .toPromise();
  }

  get_tracked_items_template(): Promise<any> {
    return this._http
      .get(`${environment.apiUrl}/conversations/tracked-items.template`)
      .toPromise();
  }

  get_tracked_items_default_template() {
    const params = `?is_default=${true}`;
    return this._http
      .get(
        `${environment.apiUrl}/conversations/tracked-items.template${params}`,
      )
      .toPromise();
  }

  update_tracked_items_template(template_uuid, template): Observable<any> {
    const data = {
      name: template.name,
    };

    return this._http.put(
      `${environment.apiUrl}/conversations/tracked-items.template/${template_uuid}`,
      data,
    );
  }

  delete_tracked_items_template(template_uuid): Observable<any> {
    return this._http.delete(
      `${environment.apiUrl}/conversations/tracked-items.template/${template_uuid}`,
    );
  }

  get_tracked_items_template_detail(template_uuid): Promise<any> {
    return this._http
      .get(
        `${environment.apiUrl}/conversations/tracked-items.template/${template_uuid}`,
      )
      .toPromise();
  }

  get_conversations(): Promise<any> {
    return this._http.get(`${environment.apiUrl}/conversations/`).toPromise();
  }

  get_conversation(conversation_id): Promise<any> {
    return this._http
      .get(`${environment.apiUrl}/conversations/${conversation_id}`)
      .toPromise();
  }

  get_conversation_by_company_id(company_id, onlyId = false): Promise<any> {
    let params = `?onlyId=${onlyId}`;
    return this._http
      .get(`${environment.apiUrl}/conversations/company/${company_id}${params}`)
      .toPromise();
  }

  get_conversation_uuid_by_company_uuid(company_uuid: string): Promise<any> {
    return this._http
      .get(`${environment.apiUrl}/conversations/company/${company_uuid}`)
      .toPromise();
  }

  submit_answer(conversation_id, data: FormData): Promise<any> {
    return this._http
      .patch(
        `${environment.apiUrl}/conversations/${conversation_id}/tracked`,
        data,
      )
      .toPromise();
  }

  submit_answer_v2(conversation_id, data: FormData): Observable<any> {
    const headers = new HttpHeaders();
    return this._http
      .patch(
        `${environment.apiUrl}/conversations/${conversation_id}/tracked`,
        data,
        {
          headers,
          reportProgress: true,
          observe: "events",
        },
      )
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: "progress", message: progress };

            case HttpEventType.Response:
              return { status: "completed" };
          }
        }),
      );
  }

  answer_tracked_item(tracked_item_id, satisfied): Promise<any> {
    let data = {
      satisfied: satisfied,
    };

    return this._http
      .post(
        `${environment.apiUrl}/conversations/answer/${tracked_item_id}`,
        data,
      )
      .toPromise();
  }

  comment_tracked_item(tracked_item_id, message): Promise<any> {
    const data = {
      message: message,
    };

    return firstValueFrom(
      this._http.post(
        `${environment.apiUrl}/conversations/comment/${tracked_item_id}`,
        data,
      ),
    );
  }

  editTrackedItemComment(comment_id: any, message: string) {
    return this._http.patch(
      `${environment.apiUrl}/conversations/comment/${comment_id}`,
      { message },
    );
  }

  deleteTrackedItemComment(comment_id: any) {
    return this._http.delete(
      `${environment.apiUrl}/conversations/comment/${comment_id}`,
    );
  }

  restoreTrackedItemComment(comment_id: any) {
    return this._http.put(
      `${environment.apiUrl}/conversations/comment/${comment_id}`,
      {},
    );
  }

  getTrackedItemComments(trackedItemId: number) {
    return this._http.get(
      `${environment.apiUrl}/conversations/comment/${trackedItemId}`,
    );
  }

  add_message_file(form, conversation_id): Promise<any> {
    // const headers = new Headers();
    // headers.set("Authorization", "JWT " + this.loginService.get_access_token());
    // const options = new RequestOptions({ headers: headers });

    console.log(form);

    return this._http
      .post(`${environment.apiUrl}/conversations/${conversation_id}/file`, form)
      .toPromise();
  }

  read_conversation(conversation_id): Promise<any> {
    if (conversation_id !== undefined) {
      return this._http
        .post(`${environment.apiUrl}/conversations/${conversation_id}/read`, {})
        .toPromise();
    }
  }

  get_conversations_read_status(): Promise<any> {
    return this._http
      .get(`${environment.apiUrl}/conversations/read.status`)
      .toPromise();
  }

  sendReminder(conversation_uuid: string): Promise<any> {
    return this._http
      .post(
        `${environment.apiUrl}/conversations/${conversation_uuid}/reminder`,
        {},
      )
      .toPromise();
  }

  toggleNotifications(conversation_id, user_id): Promise<any> {
    const data = {
      user_id: user_id,
    };

    return this._http
      .patch(
        `${environment.apiUrl}/conversations/${conversation_id}/notifications.toggle`,
        data,
      )
      .toPromise();
  }

  save_notification_settings(conversation_id, settings) {
    return this._http
      .patch(
        `${environment.apiUrl}/conversations/${conversation_id}/settings`,
        settings,
      )
      .toPromise();
  }

  get_private_file(etag) {
    return `${environment.apiUrl}/conversations/file/${etag}/private`;
  }

  get_private_resource(resource_id) {
    return `${environment.apiUrl}/conversations/file/${resource_id}/resource`;
  }

  get_etag_by_url(url) {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     Authorization: "JWT " + this.loginService.get_access_token()
    //   })
    // };

    return this._http.post(`${environment.apiUrl}/conversations/file/etag`, {
      url: url,
    });
  }

  get_private_file_test(etag) {
    return this._http.get(
      `${environment.apiUrl}/conversations/file/${etag}/url`,
    );
  }

  get_conversation_files(conversation_id) {
    return this._http
      .get(`${environment.apiUrl}/conversations/${conversation_id}/file`)
      .toPromise();
  }

  updateConversationsData(clients): void {
    this.opened_tracked_items = clients
      .map((c) => {
        return c.open_tracked_items;
      })
      .reduce((acc, curr) => {
        return acc + curr;
      });
  }

  updateOpenTrackedItemsBadge(clients): void {
    if (clients !== undefined && clients !== null && clients.length > 0) {
      this.opened_tracked_items = clients
        .map((c) => {
          return c.open_tracked_items;
        })
        .reduce((acc, curr) => {
          return acc + curr;
        });
    }
  }

  updateReadStatusBadge(clients, conversation_id = null): void {
    console.log("Updating Read Status Badge");
    this.get_conversations_read_status().then((res: any) => {
      this.read_status = res.conversations;

      console.log("Read statuses", this.read_status);

      for (let x = 0; x < this.read_status.length; x++) {
        for (let y = 0; y < clients.length; y++) {
          if (this.read_status[x].company_id == clients[y].id) {
            clients[y]["read"] = this.read_status[x].read;
            clients[y]["company_conversation"]["read"] =
              this.read_status[x].read;
          }
        }
      }

      console.log("Clients after read status change", clients);

      this.unread_conversations = clients.filter((c) => {
        return !c["company_conversation"].read;
      }).length;

      if (conversation_id !== null) {
        this.forceUnread.next({ conversation_id: conversation_id });
      }
    });
  }

  close_tracked_item(tracked_item_id: any): Observable<any> {
    return this._http.patch(
      `${environment.apiUrl}/conversations/close/${tracked_item_id}`,
      {},
    );
  }

  get_tracked_item(trackedItemUuid): Promise<any> {
    return this._http
      .get(
        `${environment.apiUrl}/conversations/tracked-item/${trackedItemUuid}`,
      )
      .toPromise();
  }

  getProfilePicture(user_id) {
    return `${environment.apiUrl}/user/${user_id}/picture`;
  }

  setAutoRemind(trackedItemUuid: string, remindIn: string) {
    return this._http.post(
      `${environment.apiUrl}/conversations/tracked-items/set-auto-reminder/${trackedItemUuid}`,
      { remindIn },
    );
  }

  updateTrackedItemMessage(
    conversationId: number,
    trackedUuid: string,
    message: string,
  ) {
    return this._http.patch(
      `${environment.apiUrl}/conversations/${conversationId}/tracked/${trackedUuid}`,
      { message },
    );
  }

  // this function should call the API to remove a file from the conversation
  removeFile(conversation_id, file_id) {
    return this._http.delete(
      `${environment.apiUrl}/conversations/${conversation_id}/file/${file_id}`,
    );
  }

  get_conversation_users(conversationId: number): Promise<any> {
    const url = `${environment.apiUrl}/company/users/${conversationId}`;
    return this._http.get(url).toPromise();
  }

  sendMessageFromBatchAction(
    message: string,
    conversations: IConversation[],
  ): Promise<any> {
    const url = `${environment.apiUrl}/conversations/batch-action-message`;
    return this._http.post(url, { message, conversations }).toPromise();
  }

  getLastTrackedItemsReminder(conversationUuid: string): Promise<any> {
    const url = `${environment.apiUrl}/conversations/tracked-items-last-reminder?conversation=${conversationUuid}`;
    return this._http.get(url).toPromise();
  }
}
